import { twMerge } from 'tailwind-merge';

interface CardBodyProps {
  children: React.ReactNode;
  className?: string;
}

export function CardBody({ children, className }: CardBodyProps) {
  return <div className={twMerge('p-6', className)}>{children}</div>;
}
